module.exports = __webpack_public_path__ + "img/alert.8b4c356f.svg";